import type { ReactNode } from "react";
import { GameScreen, GameSteps } from "./components";
import type { GameScreenProps } from "./components/gameScreen/gameScreen.component";

interface GameDemoProps {
  ariaLabel: string;
  steps: {
    labels: string[];
    activeIndex: number;
    isComplete: boolean;
    ariaLabel: string;
  };
  // The game itself (wheel, scratch card) with its buttons.
  children: ReactNode;
  screen: GameScreenProps;
  // Optional controls above the steps (the scratch card's journey picker).
  controls?: ReactNode;
}

// Shared frame for the Spin & Win / Scratch & Win "Try it" demos: a white
// panel with the step pills, the game on the left and the customer's phone
// on the right. Below lg they stack with the phone first, so the result is
// the first thing a phone visitor sees.
const GameDemo = ({
  ariaLabel,
  steps,
  children,
  screen,
  controls,
}: GameDemoProps) => (
  <figure
    role="group"
    aria-label={ariaLabel}
    className="grid w-full gap-5 rounded-[30px] bg-white px-3.5 py-[18px] shadow-card sm:p-7"
  >
    {controls}
    <GameSteps {...steps} />
    <div className="grid items-center justify-center gap-7 lg:grid-cols-[minmax(0,1fr)_minmax(0,300px)]">
      <div className="grid min-w-0 justify-items-center gap-3.5">
        {children}
      </div>
      <div className="order-first w-full lg:order-none">
        <GameScreen {...screen} />
      </div>
    </div>
  </figure>
);

export default GameDemo;
